/*
 ** 色彩体系
 */
import { palette } from './palette';
const { qunar, orange, gray, red, green, silver, pure, yellow, brown, golden } = palette;
// 基础场景色颜色
const baseColor = {
    // 品牌色
    brandText: qunar.shade2,
    brand: qunar.shade3,
    brandBorder: qunar.shade8,
    brandBackground: qunar.shade10,
    // 价格/促销类
    price: orange.shade3,
    priceIcon: orange.shade4,
    priceBorder: orange.shade8,
    priceBackground: orange.shade10,
    // 正向/有益类
    success: green.shade3,
    successIcon: green.shade4,
    successBorder: green.shade8,
    successBackground: green.shade10,
    // 报错/警示类
    warning: red.shade3,
    warningIcon: red.shade4,
    warningBorder: red.shade8,
    warningBackground: red.shade10,
    // 评价/星级
    level: yellow.shade3,
    levelIcon: yellow.shade4,
    levelBorder: yellow.shade8,
    levelBackground: yellow.shade10,
    // 酒店会员/权益
    brown: brown.shade1,
    brownIcon: brown.shade6,
    brownBorder: brown.shade8,
    brownBackground: brown.shade10,
    // 服务包/会员/金
    golden: golden.shade3,
    goldenIcon: golden.shade4,
    goldenBorder: golden.shade8,
    goldenBackground: golden.shade9,
    // 服务包/会员/钻石/银
    silver: silver.shade3,
    silverIcon: silver.shade4,
    silverBorder: silver.shade8,
    silverBackground: silver.shade10,
    // 低价产品
    cheap: green.shade3,
    cheapIcon: green.shade4,
    cheapBorder: green.shade8,
    cheapBackground: green.shade10,
    // 字体颜色
    black: pure.shade1,
    text1: gray.shade1,
    text2: gray.shade2,
    text3: gray.shade3,
    // 分割线/背景色
    disableText: gray.shade6,
    disableBtn: gray.shade8,
    line: gray.shade8,
    background1: gray.shade9,
    background2: silver.shade9,
    white: pure.shade2
};
// 按钮配色
const buttonColors = {
    primaryBackground: qunar.shade3,
    primaryText: qunar.shade2,
    primaryBorder: qunar.shade3,
    priceBackground: orange.shade3,
    priceText: orange.shade3,
    priceBorder: orange.shade3,
    priceOutlineBorder: orange.shade4,
    normalBorder: gray.shade6,
    normalText: gray.shade1,
    disableBackground: gray.shade8,
    disableBorder: gray.shade8,
    disableText: gray.shade6,
    white: pure.shade2
};
// Tips配色
const tipColors = {
    warningBackground: red.shade10,
    warningText: red.shade3,
    warningBrand: red.shade4,
    simpleBackground: gray.shade10,
    simpleText: gray.shade2,
    simpleBrand: qunar.shade2,
    friendlyBackground: green.shade10,
    friendlyText: green.shade3,
    friendlyBrand: green.shade4,
    powerfulBackground: orange.shade10,
    powerfulText: orange.shade3,
    powerfulBrand: orange.shade4
};
// NavBar组件配色
const navBarColors = {
    title: gray.shade1,
    subtitle: gray.shade2,
    arrow: gray.shade1,
    icon: gray.shade1,
    iconText: gray.shade1,
    primaryBackground: qunar.shade3,
    white: pure.shade2
};
// Tab组件配色
const tabColor = {
    backgroundColor: pure.shade2,
    bottomLineColor: gray.shade8,
    selectedColor: qunar.shade2,
    unselectedColor: gray.shade2
};
// AnimatedTab组件配色
const animatedTabColor = {
    backgroundColor: pure.shade2,
    widgetColorStart: '#99F8FF',
    widgetColorEnd: '#00EEFF',
    selectedColor: gray.shade1,
    unselectedColor: gray.shade2
};
// NumberInputer组件配色
const numberInputerColor = {
    typingBg: qunar.shade10,
    typingColor: gray.shade1
};
// Review组件配色
const reviewColor = {
    npsBorderColor: gray.shade6,
    npsTextColor: gray.shade2
};
// RadioBox组件配色
const radioBoxColors = {
    icon: qunar.shade2,
    brandText: qunar.shade2
};
// CheckBox组件配色
const checkBoxColors = {
    icon: gray.shade10,
    brand: qunar.shade3,
    text: gray.shade1,
    brandText: qunar.shade2,
    brandBackground: qunar.shade10,
    whiteBackground: pure.shade2,
    silverBorder: silver.shade8,
    silverBackgroud: silver.shade10
};
// Select组件配色
const selectColors = {
    text: gray.shade1,
    disableText: gray.shade6,
    brandText: qunar.shade2,
    brandBackground: qunar.shade10,
    whiteBackground: pure.shade2,
    line: gray.shade8,
    silverBorder: silver.shade8,
    silverBackgroud: silver.shade10
};
const popupLayerColors = {
    titleColor: gray.shade1,
    maskBackground: pure.shade1,
    contentBackground: pure.shade2,
    iconColor: gray.shade2
};
// Picker组件配色
const pickerColors = {
    titleColor: gray.shade1,
    textColor: gray.shade3,
    white: pure.shade2,
    simpleBrand: qunar.shade2,
    silverBorder: silver.shade8
};
// Button 和Label 的渐变背景色，橙色渐变
const lrGradientColors = {
    leftColor: '#FF950A',
    rightColor: '#F86355'
};
//品牌蓝色渐变
const brandGradient = {
    leftColor: '#66F6FF',
    rightColor: '#26DAE7'
};
const tagColors = {
    normalTextColor: gray.shade1,
    selectedTextColor: qunar.shade2,
    itemNormalBgColor: gray.shade9,
    itemSelectedBgColor: qunar.shade10,
    normalBorderColor: gray.shade9,
    selectedBorderColor: qunar.shade2,
    backgroundColor: pure.shade2
};
// 色彩汇总
export const scenes = {
    baseColor,
    buttonColors,
    navBarColors,
    tabColor,
    animatedTabColor,
    numberInputerColor,
    reviewColor,
    tipColors,
    radioBoxColors,
    checkBoxColors,
    selectColors,
    popupLayerColors,
    pickerColors,
    lrGradientColors,
    brandGradient,
    tagColors
};
